var jaconv;
!function (n) {
  var e = {
      "\u3042": "A",
      "\u3044": "I",
      "\u3046": "U",
      "\u3048": "E",
      "\u304A": "O",
      "\u304B": "KA",
      "\u304D": "KI",
      "\u304F": "KU",
      "\u3051": "KE",
      "\u3053": "KO",
      "\u3055": "SA",
      "\u3057": "SHI",
      "\u3059": "SU",
      "\u305B": "SE",
      "\u305D": "SO",
      "\u305F": "TA",
      "\u3061": "CHI",
      "\u3064": "TSU",
      "\u3066": "TE",
      "\u3068": "TO",
      "\u306A": "NA",
      "\u306B": "NI",
      "\u306C": "NU",
      "\u306D": "NE",
      "\u306E": "NO",
      "\u306F": "HA",
      "\u3072": "HI",
      "\u3075": "FU",
      "\u3078": "HE",
      "\u307B": "HO",
      "\u307E": "MA",
      "\u307F": "MI",
      "\u3080": "MU",
      "\u3081": "ME",
      "\u3082": "MO",
      "\u3084": "YA",
      "\u3086": "YU",
      "\u3088": "YO",
      "\u3089": "RA",
      "\u308A": "RI",
      "\u308B": "RU",
      "\u308C": "RE",
      "\u308D": "RO",
      "\u308F": "WA",
      "\u3090": "I",
      "\u3091": "E",
      "\u3092": "O",
      "\u3041": "A",
      "\u3043": "I",
      "\u3045": "U",
      "\u3047": "E",
      "\u3049": "O",
      "\u304C": "GA",
      "\u304E": "GI",
      "\u3050": "GU",
      "\u3052": "GE",
      "\u3054": "GO",
      "\u3056": "ZA",
      "\u3058": "JI",
      "\u305A": "ZU",
      "\u305C": "ZE",
      "\u305E": "ZO",
      "\u3060": "DA",
      "\u3062": "JI",
      "\u3065": "ZU",
      "\u3067": "DE",
      "\u3069": "DO",
      "\u3070": "BA",
      "\u3073": "BI",
      "\u3076": "BU",
      "\u3079": "BE",
      "\u307C": "BO",
      "\u3071": "PA",
      "\u3074": "PI",
      "\u3077": "PU",
      "\u307A": "PE",
      "\u307D": "PO",
      "\u304D\u3083": "KYA",
      "\u304D\u3085": "KYU",
      "\u304D\u3087": "KYO",
      "\u3057\u3083": "SHA",
      "\u3057\u3085": "SHU",
      "\u3057\u3087": "SHO",
      "\u3061\u3083": "CHA",
      "\u3061\u3085": "CHU",
      "\u3061\u3087": "CHO",
      "\u3061\u3047": "CHE",
      "\u306B\u3083": "NYA",
      "\u306B\u3085": "NYU",
      "\u306B\u3087": "NYO",
      "\u3072\u3083": "HYA",
      "\u3072\u3085": "HYU",
      "\u3072\u3087": "HYO",
      "\u307F\u3083": "MYA",
      "\u307F\u3085": "MYU",
      "\u307F\u3087": "MYO",
      "\u308A\u3083": "RYA",
      "\u308A\u3085": "RYU",
      "\u308A\u3087": "RYO",
      "\u304E\u3083": "GYA",
      "\u304E\u3085": "GYU",
      "\u304E\u3087": "GYO",
      "\u3058\u3083": "JA",
      "\u3058\u3085": "JU",
      "\u3058\u3087": "JO",
      "\u3073\u3083": "BYA",
      "\u3073\u3085": "BYU",
      "\u3073\u3087": "BYO",
      "\u3074\u3083": "PYA",
      "\u3074\u3085": "PYU",
      "\u3074\u3087": "PYO"
    },
    u = {
      AA: !0,
      EE: !0,
      II: !1,
      OO: !0,
      OU: !0,
      UU: !0
    },
    h = function h(n, t) {
      var r = null,
        o = null;
      return t + 1 < n.length && (o = n.substring(t, t + 2), r = e[o]), !r && t < n.length && (o = n.substring(t, t + 1), r = e[o]), {
        c: o,
        h: r || null
      };
    };
  n.toHebon = function (n) {
    for (var t = "", r = "", o = 0; o < n.length;) {
      var e = h(n, o);
      if ("\u3063" == e.c) null != (a = h(n, o + 1)).h && (0 == a.h.indexOf("CH") ? e.h = "T" : e.h = a.h.substring(0, 1));else if ("\u3093" == e.c) {
        var a;
        null != (a = h(n, o + 1)).h && -1 != "BMP".indexOf(a.h.charAt(0)) ? e.h = "M" : e.h = "N";
      } else "\u30FC" == e.c && (e.h = "");
      if (null != e.h) {
        if (null != r) {
          var c = r + e.h;
          2 < c.length && (c = c.substring(c.length - 2)), u[c] && (e.h = "");
        }
        t += e.h;
      } else t += e.c;
      r = e.h, e.c, o += e.c.length;
    }
    return t;
  };
}(jaconv || (jaconv = {})), function (n) {
  var e = "\u3041".charCodeAt(0),
    a = "\u3096".charCodeAt(0),
    c = "\u30A1".charCodeAt(0),
    u = "\u30F6".charCodeAt(0);
  n.toKatakana = function (n) {
    for (var t = "", r = 0; r < n.length; r += 1) {
      var o = n.charCodeAt(r);
      t += e <= o && o <= a ? String.fromCharCode(o - e + c) : n.charAt(r);
    }
    return t;
  }, n.toHiragana = function (n) {
    for (var t = "", r = 0; r < n.length; r += 1) {
      var o = n.charCodeAt(r);
      t += c <= o && o <= u ? String.fromCharCode(o - c + e) : n.charAt(r);
    }
    return t;
  };
}(jaconv || (jaconv = {})), function (n) {
  "object" == typeof exports && (module.exports = n);
}(jaconv || (jaconv = {})), function (n) {
  var t = function t(n) {
      var c = {},
        u = {};
      if (n.length % 2 != 0) throw "bad data length:" + n.length;
      for (var t, r, o = n.length / 2, e = 0; e < o; e += 1) t = n[2 * e], r = n[2 * e + 1], c[t] || (c[t] = r), u[r] || (u[r] = t);
      return {
        convert: function convert(n, t) {
          for (var r = t ? u : c, o = "", e = 0; e < n.length; e += 1) {
            var a;
            e + 1 < n.length && (a = r[n.substring(e, e + 2)]) ? (o += a, e += 1) : (a = r[n.substring(e, e + 1)]) ? o += a : o += n.substring(e, e + 1);
          }
          return o;
        }
      };
    },
    r = t([" ", "\u3000", "!", "\uFF01", '"', "\u201D", '"', "\u201C", "#", "\uFF03", "$", "\uFF04", "%", "\uFF05", "&", "\uFF06", "'", "\u2019", "(", "\uFF08", ")", "\uFF09", "*", "\uFF0A", "+", "\uFF0B", ",", "\uFF0C", "-", "\uFF0D", ".", "\uFF0E", "/", "\uFF0F", "0", "\uFF10", "1", "\uFF11", "2", "\uFF12", "3", "\uFF13", "4", "\uFF14", "5", "\uFF15", "6", "\uFF16", "7", "\uFF17", "8", "\uFF18", "9", "\uFF19", ":", "\uFF1A", ";", "\uFF1B", "<", "\uFF1C", "=", "\uFF1D", ">", "\uFF1E", "?", "\uFF1F", "@", "\uFF20", "A", "\uFF21", "B", "\uFF22", "C", "\uFF23", "D", "\uFF24", "E", "\uFF25", "F", "\uFF26", "G", "\uFF27", "H", "\uFF28", "I", "\uFF29", "J", "\uFF2A", "K", "\uFF2B", "L", "\uFF2C", "M", "\uFF2D", "N", "\uFF2E", "O", "\uFF2F", "P", "\uFF30", "Q", "\uFF31", "R", "\uFF32", "S", "\uFF33", "T", "\uFF34", "U", "\uFF35", "V", "\uFF36", "W", "\uFF37", "X", "\uFF38", "Y", "\uFF39", "Z", "\uFF3A", "[", "\uFF3B", "\\", "\uFFE5", "]", "\uFF3D", "^", "\uFF3E", "_", "\uFF3F", "`", "\u2018", "a", "\uFF41", "b", "\uFF42", "c", "\uFF43", "d", "\uFF44", "e", "\uFF45", "f", "\uFF46", "g", "\uFF47", "h", "\uFF48", "i", "\uFF49", "j", "\uFF4A", "k", "\uFF4B", "l", "\uFF4C", "m", "\uFF4D", "n", "\uFF4E", "o", "\uFF4F", "p", "\uFF50", "q", "\uFF51", "r", "\uFF52", "s", "\uFF53", "t", "\uFF54", "u", "\uFF55", "v", "\uFF56", "w", "\uFF57", "x", "\uFF58", "y", "\uFF59", "z", "\uFF5A", "{", "\uFF5B", "|", "\uFF5C", "}", "\uFF5D", "~", "\uFF5E"]),
    o = t(["\u3002", "\uFF61", "\u300C", "\uFF62", "\u300D", "\uFF63", "\u3001", "\uFF64", "\u30FB", "\uFF65", "\u30F2", "\uFF66", "\u30A1", "\uFF67", "\u30A3", "\uFF68", "\u30A5", "\uFF69", "\u30A7", "\uFF6A", "\u30A9", "\uFF6B", "\u30E3", "\uFF6C", "\u30E5", "\uFF6D", "\u30E7", "\uFF6E", "\u30C3", "\uFF6F", "\u30FC", "\uFF70", "\u30A2", "\uFF71", "\u30A4", "\uFF72", "\u30A6", "\uFF73", "\u30A8", "\uFF74", "\u30AA", "\uFF75", "\u30AB", "\uFF76", "\u30AD", "\uFF77", "\u30AF", "\uFF78", "\u30B1", "\uFF79", "\u30B3", "\uFF7A", "\u30AC", "\uFF76\uFF9E", "\u30AE", "\uFF77\uFF9E", "\u30B0", "\uFF78\uFF9E", "\u30B2", "\uFF79\uFF9E", "\u30B4", "\uFF7A\uFF9E", "\u30B5", "\uFF7B", "\u30B7", "\uFF7C", "\u30B9", "\uFF7D", "\u30BB", "\uFF7E", "\u30BD", "\uFF7F", "\u30B6", "\uFF7B\uFF9E", "\u30B8", "\uFF7C\uFF9E", "\u30BA", "\uFF7D\uFF9E", "\u30BC", "\uFF7E\uFF9E", "\u30BE", "\uFF7F\uFF9E", "\u30BF", "\uFF80", "\u30C1", "\uFF81", "\u30C4", "\uFF82", "\u30C6", "\uFF83", "\u30C8", "\uFF84", "\u30C0", "\uFF80\uFF9E", "\u30C2", "\uFF81\uFF9E", "\u30C5", "\uFF82\uFF9E", "\u30C7", "\uFF83\uFF9E", "\u30C9", "\uFF84\uFF9E", "\u30CA", "\uFF85", "\u30CB", "\uFF86", "\u30CC", "\uFF87", "\u30CD", "\uFF88", "\u30CE", "\uFF89", "\u30CF", "\uFF8A", "\u30D2", "\uFF8B", "\u30D5", "\uFF8C", "\u30D8", "\uFF8D", "\u30DB", "\uFF8E", "\u30D0", "\uFF8A\uFF9E", "\u30D3", "\uFF8B\uFF9E", "\u30D6", "\uFF8C\uFF9E", "\u30D9", "\uFF8D\uFF9E", "\u30DC", "\uFF8E\uFF9E", "\u30D1", "\uFF8A\uFF9F", "\u30D4", "\uFF8B\uFF9F", "\u30D7", "\uFF8C\uFF9F", "\u30DA", "\uFF8D\uFF9F", "\u30DD", "\uFF8E\uFF9F", "\u30DE", "\uFF8F", "\u30DF", "\uFF90", "\u30E0", "\uFF91", "\u30E1", "\uFF92", "\u30E2", "\uFF93", "\u30E4", "\uFF94", "\u30E6", "\uFF95", "\u30E8", "\uFF96", "\u30E9", "\uFF97", "\u30EA", "\uFF98", "\u30EB", "\uFF99", "\u30EC", "\uFF9A", "\u30ED", "\uFF9B", "\u30EF", "\uFF9C", "\u30F3", "\uFF9D", "\u30F4", "\uFF73\uFF9E", "\u309B", "\uFF9E", "\u309C", "\uFF9F", "\u30F0", "\uFF72", "\u30F1", "\uFF74", "\u30EE", "\uFF9C", "\u30F5", "\uFF76", "\u30F6", "\uFF79"]);
  function e(n) {
    return r.convert(n, !0);
  }
  function a(n) {
    return r.convert(n, !1);
  }
  function c(n) {
    return o.convert(n, !1);
  }
  function u(n) {
    return o.convert(n, !0);
  }
  n.toHanAscii = e, n.toZenAscii = a, n.toHanKana = c, n.toZenKana = u, n.toHan = function (n) {
    return e(c(n));
  }, n.toZen = function (n) {
    return a(u(n));
  }, n.normalize = function (n) {
    return e(u(n));
  };
}(jaconv || (jaconv = {}));